import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-neutral-100 px-3 min-h-screen" }
const _hoisted_2 = {
  class: "flex-grow flex flex-col items-center justify-center",
  autocomplete: "off"
}
const _hoisted_3 = { class: "mt-8 mb-8 sm:mb-20 text-center max-w-full w-[500px] text-neutral-800" }

import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import DomainSearch from '@/components/DomainSearch.vue';
import SponsorshipBanner from '@/components/layout/SponsorshipBanner.vue';
import { SearchPageAdUnit } from '@/common/adSlots';
import AdUnit from '@/components/ads/AdUnit.vue';
import ContentPage from '@/components/layout/ContentPage.vue';
import { showRedirectPizzaAds } from '@/common/dateTime';
import RedirectPizzaBanner from '@/components/layout/RedirectPizzaBanner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchWithHiddenContentPage',
  props: {
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: (encodedDomain: string) => `/domains/${encodedDomain}/dns-records/`,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();

function redirectTo(domain: string): void {
  router.push(props.domainSearchToUrl(domain));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: "img/logo.svg",
          class: "max-w-full my-8",
          alt: "NsLookup logo",
          width: "337",
          height: "57"
        }, null, -1)),
        _createVNode(DomainSearch, {
          autofocus: "",
          emphasize: "",
          onSubmitted: redirectTo,
          "button-text": __props.searchButtonText,
          class: "h-12 max-w-full w-[500px]"
        }, null, 8, ["button-text"]),
        _createElementVNode("p", _hoisted_3, [
          _renderSlot(_ctx.$slots, "search-explanation"),
          (_unref(showRedirectPizzaAds)())
            ? (_openBlock(), _createBlock(RedirectPizzaBanner, {
                key: 0,
                class: "mt-20 mx-auto sm:hidden"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(AdUnit, {
          class: "mx-auto",
          config: _unref(SearchPageAdUnit)
        }, null, 8, ["config"])
      ]),
      (_unref(showRedirectPizzaAds)())
        ? (_openBlock(), _createBlock(RedirectPizzaBanner, {
            key: 0,
            class: "mb-6 mt-8 mx-auto hidden sm:flex"
          }))
        : (_openBlock(), _createBlock(SponsorshipBanner, {
            key: 1,
            class: "mb-6 mt-8 mx-auto"
          }))
    ]),
    _createVNode(ContentPage, {
      "domain-search-to-url": __props.domainSearchToUrl,
      "search-button-text": __props.searchButtonText
    }, {
      content: _withCtx(() => [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _: 3
    }, 8, ["domain-search-to-url", "search-button-text"])
  ], 64))
}
}

})